import { useQuery } from '@tanstack/react-query';
import { useServices } from '@/lib/ServicesContext';

/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * TOŻSAMOŚĆ WYDANIA — ZZA SESJI, NIE Z PUBLICZNEGO PAKIETU
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * ┌─ DLACZEGO NIE Z `buildInfo` ────────────────────────────────────────────────────────────────┐
 * │ `buildInfo` jest wpiekany w `assets/index-*.js` — plik, który każdy pobiera bez logowania.  │
 * │ Zmierzone 2026-08-28: pełny SHA i nazwa gałęzi prywatnego repozytorium leżały tam jawnie.   │
 * │                                                                                              │
 * │ Rewizja nie jest hasłem, ale mówi wprost, KTÓRY kod tu stoi — a więc które znane słabości.  │
 * │ Operator tego potrzebuje. Przechodzień nie. Dlatego wartość przychodzi z backendu, który    │
 * │ czyta ją ze znacznika położonego przez wdrożenie, i tylko dla zalogowanego.                  │
 * └──────────────────────────────────────────────────────────────────────────────────────────────┘
 *
 * `sha: null` znaczy „ta instancja nie wie" (brak znacznika — dev, testy), a NIE „zbudowano
 * z nieznanego commita". Pierwsze jest normalne, drugie byłoby usterką wydania — i ekran ma
 * je rozróżniać, zamiast pokazywać w obu wypadkach to samo.
 */
export interface Wydanie {
  wersja: string | null;
  sha: string | null;
  zrodlo_znacznika: string;
}

export function useWydanie() {
  const { api } = useServices();
  return useQuery({
    queryKey: ['wydanie'],
    queryFn: () => api.get<Wydanie>('crm', '/api/cc/wydanie'),
    /*
     * SHA zmienia się wyłącznie przy wdrożeniu, a wdrożenie i tak przeładowuje kartę.
     * Odpytywanie częściej byłoby ruchem bez treści.
     */
    staleTime: 10 * 60_000,
    retry: false,
  });
}

/** Skrót do wyświetlenia. `null` zostaje `null` — nie zamieniamy braku na „unknown". */
export function skrotSha(sha: string | null | undefined): string | null {
  if (!sha) return null;
  return sha.slice(0, 8);
}
